export default __webpack_public_path__ + "static/media/dsv-seur-bulky-dom.9b961a61.svg";